import React, { useState } from "react";

import { Close } from "@mui/icons-material";
import {
  Box,
  Button,
  Modal,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";

import { ReactComponent as ViewIcon } from "../../Assets/Images/viewIcon.svg";
import { formatDate, hexToRgba } from "../../Utils";
import { useTheme } from "@mui/material/styles";

const historyColumns = [
  {
    label: "Updated At",
    value: "created_at",
  },
  {
    label: "Updated By",
    value: "updatedBy",
  },
  {
    label: "Data",
    value: "data",
  },
];

function HistoryModal({ title, columns = historyColumns, data }) {
  const [historyModel, setHistoryModel] = useState(false);
  const theme = useTheme();

  return (
    <div>
      {
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            alignItems: { xs: "start", sm: "center" },
            margin: "0 auto",
          }}
        >
          <div style={{ marginRight: "10px" }}>
            <Button
              sx={{
                minWidth: "40px",
                background:`${hexToRgba(theme.palette.primary.main, 0.20)} !important`,
                borderRadius: "10px",
                color: `${theme.palette.primary.main}`,
                fontSize: "14px",
                fontWeight: 400,
              }}
              onClick={() => setHistoryModel(true)}
            >
               <ViewIcon
                style={{
                  fill: `${theme.palette.primary.main}`, 
                  cursor: "pointer",
                }}
                alt="view"
              /> &nbsp; View History
            </Button>
          </div>
          <div>
            <p style={{ color: "black", textAlign: "start" }}>
              Last Updated at: {formatDate(data?.[0]?.created_at)}
            </p>
          </div>
        </Box>
      }
      <Modal
        open={historyModel}
        onClose={() => setHistoryModel(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{position:'absolute',top:'50%',left:'50%',transform:'translate(-50%, -50%)',borderRadius:'10px',width:{sm:'70%',xs:'80%'},bgcolor: "white", boxShadow: 24,p: {md:4, sm:3, xs:2},}}>
          <div style={{ display: "flex", justifyContent: "space-between",marginBottom:10 }}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              {title}
            </Typography>
            <Close
              onClick={() => setHistoryModel(false)}
              sx={{ cursor: "pointer" }}
            />
          </div>
          <TableContainer
            component={Paper}
            sx={{
              maxHeight: "68vh",
              maxWidth: {sm:'70vw',xs:'max-content'},
              boxShadow: "none",
              border: `1px solid ${theme.palette.primary.main}`,
              borderRadius: "10px",
            }}
          >
            <Table
              // stickyHeader
              sx={{ minWidth: 650, tableLayout: "auto" }}
              aria-label="simple table"
            >
              <TableHead>
                <TableRow
                  sx={{
                    background: `${hexToRgba(theme.palette.primary.main, 0.20)}`,
                    borderBottom: `1px solid ${theme.palette.primary.main}`,
                  }}
                >
                  {columns?.map((item, index) => (
                    <TableCell key={index} sx={{ fontWeight: 600, width: 100 }}>
                      {item.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {data?.map((cell, index) => {
                  return (
                    <TableRow
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                      key={index}
                    >
                      <React.Fragment key={index}>
                        {columns.map((column, cellIndex) => {
                            return (
                              <TableCell
                                key={cellIndex}
                                component="th"
                                sx={{
                                  width: 150,
                                  fontSize: "14px",
                                  // borderBottom: "none",
                                }}
                              >
                                {column.value === "data" ? (
                                  <div style={{ width: '100%'}}>
                                    <Table
                                      sx={{
                                        width: "auto",
                                        tableLayout: "auto",
                                      }}
                                      aria-label="simple table"
                                    >
                                      <TableHead>
                                        <TableRow
                                          sx={{
                                            background:
                                              `${hexToRgba(theme.palette.primary.main, 0.20)}`
                                            // borderBottom: "1px solid #FF8533"
                                          }}
                                        >
                                          <TableCell
                                            key={index}
                                            sx={{
                                              fontWeight: 600,
                                              width: 30,
                                            }}
                                          >
                                          </TableCell>
                                          {Object.keys(
                                            cell?.[column?.value]
                                          )?.map((item, index) => (
                                            <TableCell
                                              key={index}
                                              sx={{
                                                fontWeight: 600,
                                                width: 100,
                                              }}
                                            >
                                              {item}
                                            </TableCell>
                                          ))}
                                        </TableRow>
                                      </TableHead>
                                      <TableBody>
                                        <TableRow
                                          sx={{
                                            "&:last-child td, &:last-child th":
                                              { border: 0 },
                                          }}
                                        >
                                          <TableCell
                                            sx={{
                                              fontWeight: 600,
                                              width: 30,
                                              borderBottom: "none"
                                            }}
                                          >
                                            OldData
                                          </TableCell>
                                          {Object.entries(
                                            cell?.[column?.value]
                                            )?.map((item, index) => {
                                              if (item[0] === 'image') {
                                                return (
                                                  <TableCell
                                                    key={`${index}-${cellIndex}`}
                                                    sx={{
                                                      width: 100,
                                                      borderBottom: "none",
                                                    }}
                                                  >
                                                    <PetLogo
                                                      src={item[1]?.oldValue}
                                                      style={{ verticalAlign: "middle" }}
                                                    />
                                                  </TableCell>
                                                );
                                              }
                                            return (
                                              <TableCell
                                                key={`${index}-${cellIndex}`}
                                                component="th"
                                                sx={{
                                                  // width: 50,
                                                  fontSize: "14px",
                                                  borderBottom: "none",
                                                  color: "black",
                                                }}
                                              >
                                                {item[1]?.oldValue || "-"}
                                              </TableCell>
                                            );
                                          })}
                                        </TableRow>
                                        <TableRow
                                          key={index}
                                          sx={{
                                            "&:last-child td, &:last-child th":
                                              { border: 0 },
                                          }}
                                        >
                                          <TableCell
                                            key={index}
                                            sx={{
                                              fontWeight: 600,
                                              // width: 30,
                                            }}
                                          >
                                            NewData
                                          </TableCell>
                                          {Object.entries(
                                            cell?.[column?.value]
                                            )?.map((item, index) => {
                                              if (item[0] === 'image') {
                                                return (
                                                  <TableCell
                                                    key={`${index}-${cellIndex}`}
                                                    sx={{
                                                      width: 100,
                                                      borderBottom: "none",
                                                    }}
                                                  >
                                                    <PetLogo
                                                      src={item[1]?.newValue}
                                                      style={{ verticalAlign: "middle" }}
                                                    />
                                                  </TableCell>
                                                );
                                              }
                                            return (
                                              <TableCell
                                                key={index}
                                                component="th"
                                                sx={{
                                                  // width: 50,
                                                  fontSize: "14px",
                                                  borderBottom: "none",
                                                  color: "black",
                                                }}
                                              >
                                                {item[1]?.newValue || "-"}
                                              </TableCell>
                                            );
                                          })}
                                        </TableRow>
                                      </TableBody>
                                    </Table>
                                  </div>
                                ) : (
                                  cell[column.value]
                                )}
                              </TableCell>
                            );
                        })}
                      </React.Fragment>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Modal>
    </div>
  );
}

export default HistoryModal;

const PetLogo = styled("img")(() => ({
  borderRadius: "25px",
  width: "69px",
  height: "68px",
}));

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "70%",
  height: "70%",
  bgcolor: "white",
  boxShadow: 24,
  p: 4,
  // overflowY: "auto"
};
